<sc-bordered-tile>
  <sc-padding>
    <sc-flex [gap]="16" class="no-field-space">
      <sc-dictionary-text-field grow [model]="condition.value" labelDictionaryKey="tmc-yard.ui.admin.transport-options-administration.condition-label" (dictionaryChanged)="onDictionaryChanged()"></sc-dictionary-text-field>
      <sc-delete-action-button (click)="deleteRequested.emit()"></sc-delete-action-button>
    </sc-flex>
  </sc-padding>
</sc-bordered-tile>
